import React from "react";
import styles from "../styles/ecommerce.module.css";
import Header from "../components/Header";
import pic from "../assets/commercee2.png";
import payment from "../assets/ecommerce3.png";
import view from "../assets/ms.JPG";
import confirm from "../assets/commerce3.png";
import termin from "../assets/commercee2.png";
import terminal from "../assets/commerce1.png";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const Ecommerce = () => {
  return (
    <div>
      <Header />
      <div className={styles.empoweringSection}>
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <p
              style={{ fontWeight: "bold", fontSize: "30px", marginBottom:"0" }}
              className={styles.msmesLabel}
            >
              ARIFSHOP
            </p>
            <h1 className={styles.heroTitle}>
              Ecommerce Platform to Build & Grow Your Online Store in Ethiopia
            </h1>
            <p style={{ fontSize: "17px", color: "back" }}>
              Launch a branded storefront, accept Telebirr, cards, and wallets,
              and manage products, orders, and delivery from one platform built
              for Ethiopian sellers and shoppers.
            </p>
          </div>
          <div
            style={{
              paddingLeft: "100px",
              paddingRight: "100px",
              maxWidth: "800px",
            }}
          >
            <div className={styles.topImage}>
              <img
                style={{
                  borderRadius: "50px",
                  marginRight: "30px",
                  Width: "700px",
                  height: "350px",
                }}
                src={pic}
                alt="Payment terminal in a shop"
              />
            </div>
          </div>
        </div>
        <div className={styles.separat}>
          <hr
            style={{
              border: "none",
              borderTop: "1px solid #ccc",
              // margin: "40px 80px",
              // marginTop: "100px",
            }}
          />
        </div>
      </div>
      <div className={styles.helpingSection}>
        <div className={styles.helpingText}>
          <p style={{ color: "green", fontSize: "30px", marginTop:'0', marginBottom:'0' }}> WHY US?</p>
          <h2 style={{ fontSize: "24", marginTop:"0" }} className={styles.helpingTitle}>
            <span style={{ color: "silver" }}></span> Verified. Smart.
            Empowering.
          </h2>
          <p style={{ color: "black", fontSize: "17px" }}>
            Solutions for Shoppers & Sellers Alike. No more limits — from
            everyday purchases
            <br /> to managing your online store, everything happens in one
            trusted platform.
          </p>
          {/* <Link to="/pages/Partner2">
            <button className={styles.primaryButton}>Become a partner →</button>
          </Link> */}
        </div>
      </div>

      <section
        className={styles.dev}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14rem",
          marginTop: "250px",
        }}
      >
        <div className={styles.viewText}>
          <h3 style={{ fontSize: "1.3em" }}>
            <span className={styles.icon}>✦</span> Custom Domain & Subdomain Support
          </h3>
          <p style={{ color: "black", fontSize: "1em" }}>
         Each vendor can use their own domain (e.g. myshop.com) or a subdomain (e.g. vendor.arifshop.com) for a fully branded storefront.
Gives vendors a professional online presence without needing technical expertise.
          </p>

          <div className={styles.second}>
            <h3 style={{ fontSize: "1.3em" }}>
              <span className={styles.icon}>✦</span> Integrated Payment Gateways
            </h3>
            <p style={{ color: "black", fontSize: "1em" }}>
Supports major local and international payment options, including Telebirr, CBE Birr, M-Pesa, Visa and MasterCard
            </p>
          </div>

          <h3 style={{ fontSize: "1.3em" }}>
            <span className={styles.icon}>✦</span>Multi-language Support (Amharic & English)
          </h3>
          <p style={{ color: "black", fontSize: "1em" }}>
          The platform supports localization, allowing vendors and customers to interact in their preferred language.
Increases accessibility and ease of use for diverse user groups.
          </p>

          <h3 style={{ fontSize: "1.3em" }}>
            <span className={styles.icon}>✦</span>
            Advanced Delivery Options & Partner Integration
          </h3>
          <p style={{ color: "black", fontSize: "1em" }}>
        Arifshop allows vendors to offer flexible and reliable delivery services by integrating with third-party delivery providers. This gives vendors and customers multiple logistics options tailored to their needs.
          </p>

         <h3 style={{ fontSize: "1.3em" }}>
            <span className={styles.icon}>✦</span>Chatbot & Vendor Support Integration
          </h3>
          <p style={{ color: "black", fontSize: "1em" }}>
Built-in chatbot offers automated support and FAQs for both customers and vendors.
Reduces support load and improves customer satisfaction.
          </p> 
        </div>

        <div
          className={styles.solutionImage}
          style={{
            flexShrink: 0,
            maxWidth: "450px",
            // marginRight: "70px",

            position: "relative",
            display: "inline-block",
          }}
        >
          <img
            src={payment}
            alt="feature payment"
            style={{
              width: "600px",
              // marginRight: "100px",
              height: "350px",
              display: "block",
              borderRadius: "35px",
              border: "6px solid #8fbc8f",
            }}
          />
        </div>
      </section>

      <section className={styles.howItWorksSection}>
        <p style={{ fontSize: "1.4em" }} className={styles.subtitle}>
          TAKE YOUR FIRST STEP TO OUR QR CODE SYSTEM
        </p>
        <h2 className={styles.title}>How it works?</h2>

        <div className={styles.stepsContainer}>
          <div className={styles.stepCard}>
            <p style={{ fontSize: "1em" }} className={styles.stepNumber}>
              STEP 1
            </p>
            <h3 className={styles.stepTitle}>Register & Set Up Shop</h3>
            {/* <p className={styles.stepDescription}>
              Merchants can create and display unique QR codes for payments.
            </p> */}
            <img
              className={styles.stepImage}
              src={termin}
              alt="Generate QR Code"
            />
          </div>

          <div className={styles.stepCard}>
            <p style={{ fontSize: "1em" }} className={styles.stepNumber}>
              STEP 2
            </p>
            <h3 className={styles.stepTitle}>
              Add Products, Set Prices & Go Live
            </h3>
            {/* <p className={styles.stepDescription}>
              Customers scan the QR code using their mobile banking or payment
              app.
            </p> */}
            <img
              className={styles.stepImage}
              src={terminal}
              alt="Scan and Pay"
            />
          </div>

          <div className={styles.stepCard}>
            <p style={{ fontSize: "1em" }} className={styles.stepNumber}>
              STEP 3
            </p>
            <h3 className={styles.stepTitle}>
              Track Sales, Analyze Data, Offer Deals
            </h3>

            <img
              className={styles.newImage}
              src={confirm}
              alt="Confirm and Complete"
            />
          </div>
        </div>
      </section>

      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 40px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {/* Text Content */}
            <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2
                style={{
                  fontSize: "20px ",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
           Start selling online the easy way.
              </h2>
              <p style={{ fontSize: "16px" }}>
                <span style={{ color: "white", fontSize: "0.6em" }}>✦</span>{" "}
Arifshop gives you the tools to launch, manage, and grow your business  all in one place. No sophisticated technical skills needed, no hidden costs. Just a straightforward way to bring your products to the people who need them.
              </p>
           
            </div>

            {/* Image Side */}
            <div className={styles.BottomImage}
              style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}
            >
              <img
                src={pic} // your actual image path
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  height: "300PX",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Ecommerce;
